import WordTable from "./WordTable";
import { Button, ButtonReversed } from "shared/components/Button";
import useWordView from "features/homework/hooks/useWordView";
import { ViewProps, word } from "shared/types/Report";
import Modal from "shared/components/Modal";
import LoadingWithProgressBar from "shared/components/Loading";
import FilePreviewModal from "shared/components/FilePreviewModal";
import WordBatchView from "./WordBatchView";
import { EditorShell, EditorHeader, EditorTitle, EditorDesc, ActionBar, ActionHint, CountBadge } from "../homeworkUi";


const WordView = ({ list, setList, path }: ViewProps<word>) => {
    const { 
        onAddClickHandler, 
        onChangeHandler, 
        onSelectHandler, 
        selectedList, 
        onSelectAllClickHandler, 
        imageInputRefs,
        wordAudioInputRefs,
        exampleAudioInputRefs,
        onImageInputClickHandler,
        onWordAudioInputClickHandler,
        onExampleAudioInputClickHandler,
        onWordAudioChangeHandler,
        onExampleAudioChangeHandler,
        onWordAudioDeleteHandler,
        onExampleAudioDeleteHandler,
        onImageChangeHandler, 
        onFileClickHandler,
        showProgress, 
        uploadFileName, 
        progress, 
        isSaveSucceed, 
        onSuccessModalConfirmHandler, 
        selectedFile, 
        onFileModalCloseClickHandler,
        onDeleteImageClickHandler,
        onRegisterReportClickHandler,
        onDeleteClickHandler,
        isOpenBatchView,
        onBatchViewOpenClickHandler,
        onBatchViewCancelClickHandler
    } = useWordView(list, setList, path);

    const renderButtons = () => {
        if (selectedList.length) {
            return (
                <ActionBar>
                    <ActionHint>선택한 {selectedList.length}개 항목을 삭제한 뒤 저장을 눌러 주세요</ActionHint>
                    <ButtonReversed name="삭제" onButtonClick={onDeleteClickHandler}/>
                </ActionBar>
            );
        }
        return (
            <ActionBar>
                <ButtonReversed name="일괄등록" onButtonClick={onBatchViewOpenClickHandler} />
                <Button name="저장" onButtonClick={onRegisterReportClickHandler}/>
            </ActionBar>
        );
    };

    return (
        <EditorShell>
            {showProgress ? <LoadingWithProgressBar title="파일 업로드" subTitle={uploadFileName} progress={progress}/> : null}
            <Modal isOpen={isSaveSucceed} onClose={onSuccessModalConfirmHandler} title="저장 성공" content="저장에 성공하였습니다"/>
            <FilePreviewModal isOpen={selectedFile.url ? true : false} type={selectedFile.type} value={selectedFile.url} onDeleteClickHandler={onDeleteImageClickHandler} onCancelClickHandler={onFileModalCloseClickHandler}/>
            <EditorHeader>
                <div>
                    <EditorTitle>단어 등록</EditorTitle>
                    <EditorDesc>행을 추가하거나 일괄등록으로 여러 단어를 한 번에 넣을 수 있습니다. 이미지·음원은 선택 사항입니다.</EditorDesc>
                </div>
                <CountBadge>{list.length}개</CountBadge>
            </EditorHeader>
            <WordTable 
                list={list} 
                onAddClickHandler={onAddClickHandler} 
                onChangeHandler={onChangeHandler} 
                onSelectHandler={onSelectHandler} 
                selectedList={selectedList} 
                onSelectAllClickHandler={onSelectAllClickHandler}
                imageInputRefs={imageInputRefs}
                wordAudioInputRefs={wordAudioInputRefs}
                exampleAudioInputRefs={exampleAudioInputRefs}
                onImageInputClickHandler={onImageInputClickHandler}
                onWordAudioInputClickHandler={onWordAudioInputClickHandler}
                onExampleAudioInputClickHandler={onExampleAudioInputClickHandler}
                onWordAudioChangeHandler={onWordAudioChangeHandler}
                onExampleAudioChangeHandler={onExampleAudioChangeHandler}
                onWordAudioDeleteHandler={onWordAudioDeleteHandler}
                onExampleAudioDeleteHandler={onExampleAudioDeleteHandler}
                onImageChangeHandler={onImageChangeHandler}
                onFileClickHandler={onFileClickHandler}
            />
            {renderButtons()}
            <WordBatchView 
                isOpen={isOpenBatchView} 
                onCancelClickHandler={onBatchViewCancelClickHandler} 
                path={path} 
                list={list} 
                setList={setList}
            />
        </EditorShell>
    );
}

export default WordView;